import { render, staticRenderFns } from "./ExternalBasePage.vue?vue&type=template&id=6d6cf99c&scoped=true&"
import script from "./ExternalBasePage.vue?vue&type=script&lang=js&"
export * from "./ExternalBasePage.vue?vue&type=script&lang=js&"
import style0 from "./ExternalBasePage.vue?vue&type=style&index=0&id=6d6cf99c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6cf99c",
  null
  
)

export default component.exports